import { render, staticRenderFns } from "./b2c-coin-list.vue?vue&type=template&id=318c3454&"
import script from "./b2c-coin-list.vue?vue&type=script&lang=js&"
export * from "./b2c-coin-list.vue?vue&type=script&lang=js&"
import style0 from "./b2c-coin-list.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./b2c-coin-list.vue?vue&type=style&index=1&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports